@if (visible()) {
<div
  id="global_progress_bar"
  class="pointer-events-none fixed inset-x-0 top-0 z-[9998] h-0.5 overflow-hidden"
  role="progressbar"
  aria-label="Loading"
  aria-busy="true">
  <div class="global-progress-bar__indicator bg-surface-bg-primary-strong"></div>
</div>
}
